import { InAppContentDefinition, InboxMetadataDefinition } from 'modules/graphql/types';
import { ChevronLeftSmall } from 'ui/icons';
import { colors, spacing } from 'ui/theme';

import {
  inboxContainerStyle,
  inboxLine,
  inboxHeader,
  inboxImage,
  inboxSkeleton,
  inboxSubtitle,
  inboxText,
  inboxTitle,
  sendTimeLabel,
} from './styles';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useInAppPreviewContext } from '../context/InAppPreviewContext';

const DISPLAY_CONTENT = {
  defaultSubtitle: 'Body',
  defaultTitle: 'Title',
  sendTimeLabel: '2 min ago',
};

const InboxLineSkeleton = () => (
  <div style={{ ...inboxLine, width: `100%` }}>
    <div style={{ ...inboxSkeleton, height: spacing.x4, width: spacing.x4 }}></div>
    <div style={inboxText}>
      <div>
        <div style={{ ...inboxSkeleton, height: 17, width: 116, marginBottom: spacing.half }} />
        <div style={{ ...inboxSkeleton, height: 8, width: 180 }} />
      </div>
      <div style={{ ...inboxSkeleton, height: 8, width: 30 }} />
    </div>
  </div>
);

export const InboxPreview = ({ usePopulatedField }: { usePopulatedField: boolean }) => {
  const { messageInboxTitle, messageInboxSubtitle } = useInAppPreviewContext();
  const { liveTemplate } = useEditableFieldsContext();
  const {
    title = DISPLAY_CONTENT.defaultTitle,
    subtitle = DISPLAY_CONTENT.defaultSubtitle,
    icon,
  } = (liveTemplate.mediumData as InAppContentDefinition)?.inboxMetadata ||
  ({} as InboxMetadataDefinition);

  const inboxSkeletonFilled = Array(5)
    .fill({})
    .map((x, i) => <InboxLineSkeleton key={i} />);

  return (
    <div data-test="template-editor-in-app-preview" style={inboxContainerStyle}>
      <div style={inboxHeader}>
        <ChevronLeftSmall height={24} width={24} color={colors.textSecondary} />
        Inbox
      </div>
      <div style={inboxLine}>
        {icon && (
          <div>
            <img data-test="template-editor-in-app-inbox-image" style={inboxImage} src={icon} />
          </div>
        )}
        <div style={inboxText}>
          <div>
            <div style={inboxTitle} data-test="template-editor-in-app-title">
              {usePopulatedField ? messageInboxTitle : title}
            </div>
            {subtitle && (
              <div style={inboxSubtitle} data-test="template-editor-in-app-subtitle">
                {usePopulatedField ? messageInboxSubtitle : subtitle}
              </div>
            )}
          </div>
          <div style={sendTimeLabel}>{DISPLAY_CONTENT.sendTimeLabel}</div>
        </div>
      </div>
      {inboxSkeletonFilled}
    </div>
  );
};
